import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackHelpView = (userId?: string): void => {
  const route = userId ? '/inicio/ajuda' : '/ajuda';
  trackingService.trackEvent(
    'HELP',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route,
      placement: '',
      surface: '',
      flow: '',
      step: '',
      element: '',
      action: 'view',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackFaqClick = (userId?: string): void => {
  const route = userId ? '/inicio/ajuda' : '/ajuda';
  trackingService.trackEvent(
    'FAQ',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route,
      placement: 'main',
      surface: '',
      flow: 'ajuda',
      step: 'opções ajuda',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSupportChatClick = (userId?: string): void => {
  const route = userId ? '/inicio/ajuda' : '/ajuda';
  trackingService.trackEvent(
    'SUPPORT_CHAT',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route,
      placement: 'main',
      surface: '',
      flow: 'ajuda',
      step: 'opções ajuda',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackSupportPhoneClick = (userId?: string): void => {
  const route = userId ? '/inicio/ajuda' : '/ajuda';
  trackingService.trackEvent(
    'SUPPORT_PHONE',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route,
      placement: 'main',
      surface: '',
      flow: 'ajuda',
      step: 'opções ajuda',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackWhatsappChatClick = (userId?: string): void => {
  const route = userId ? '/inicio/ajuda' : '/ajuda';
  trackingService.trackEvent(
    'WHATSAPP_CHAT',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route,
      placement: 'main',
      surface: 'card',
      flow: 'ajuda',
      step: 'opções ajuda',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackPrivacyClick = (userId?: string): void => {
  const route = userId ? '/inicio/ajuda' : '/ajuda';
  trackingService.trackEvent(
    'PRIVACY',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route,
      placement: 'main',
      surface: '',
      flow: 'ajuda',
      step: 'opções ajuda',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackTermsOfUseClick = (userId?: string): void => {
  const route = userId ? '/inicio/ajuda' : '/ajuda';
  trackingService.trackEvent(
    'TERMS_OF_USE',
    PRODUCT_NAME,
    {
      page: 'ajuda',
      route,
      placement: 'main',
      surface: '',
      flow: 'ajuda',
      step: 'opções ajuda',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
